import React from 'react'
import ClientsTable from './Clients/ClientsTable'
// import EmployeeTable from './staff/EmployeeTable'

export default function Clients() {
  return (
    <div style={{padding:15}}>
        <ClientsTable />
    </div>
  )
}
